import { isRatioMetric } from '~/features/analytics'

export function recursiveSum(obj1: any, obj2: any): any {
  const result: any = {}

  // Get all unique keys from both objects
  const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)])

  // Iterate over each key in the set using a for...of loop
  for (const key of keys) {
    const value1 = obj1[key]
    const value2 = obj2[key]

    const isRatioMetric1 = isRatioMetric(value1)
    const isRatioMetric2 = isRatioMetric(value2)

    if (isRatioMetric1 && isRatioMetric2) {
      result[key] = {
        numerator: value1.numerator + value2.numerator,
        denominator: value1.denominator + value2.denominator,
      }
    } else if (isRatioMetric1 || isRatioMetric2) {
      const ratioMetric = isRatioMetric1 ? value1 : value2
      result[key] = ratioMetric
    } else if (typeof value1 === 'object' && typeof value2 === 'object' && value1 !== null && value2 !== null) {
      // If both values are objects, recurse
      result[key] = recursiveSum(value1, value2)
    } else if (typeof value1 === 'number' && typeof value2 === 'number') {
      result[key] = value1 + value2
    } else if (value1 !== undefined) {
      result[key] = value1
    } else if (value2 !== undefined) {
      result[key] = value2
    }
  }

  return result
}
